/* menu-sort.js — pure comparator for the Menu "Sort by" control (T-0148).
   No DOM, no Shopify globals: the same file is loaded by the storefront (window.ThriveMenuSort)
   and by tests/menu-sort.test.mjs (module.exports). Never estimates a figure: a card with no
   usable number is "missing" and always sorts LAST, whatever the direction. */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.ThriveMenuSort = factory();
})(typeof self !== 'undefined' ? self : this, function () {
  // mode -> which way is "better"
  var MODES = {
    sales30:  { dir: 'desc' },
    protein:  { dir: 'desc' },
    carbs:    { dir: 'asc'  },
    calories: { dir: 'asc'  }
  };

  // "32g" -> 32, "32.5" -> 32.5, " 410 Cal" -> 410, "" / "n/a" / null -> null
  function parseNum(v) {
    if (v === null || v === undefined) return null;
    var m = String(v).replace(/,/g, '').match(/-?\d+(?:\.\d+)?/);
    if (!m) return null;
    var n = parseFloat(m[0]);
    return isFinite(n) ? n : null;
  }

  // items: [{ index: <original position>, raw: <string|number|null> }]. Returns a NEW array of the
  // same items in sorted order. Stable: equal / missing values keep original `index` order.
  function sortItems(items, mode) {
    var cfg = MODES[mode];
    var list = items.slice();
    if (!cfg) return list.sort(function (a, b) { return a.index - b.index; });
    var dir = cfg.dir === 'desc' ? -1 : 1;
    function val(it) {
      var n = parseNum(it.raw);
      if (n === null) return null;
      return n;
    }
    var decorated = list.map(function (it) { return { it: it, v: val(it) }; });
    decorated.sort(function (a, b) {
      if (a.v === null && b.v === null) return a.it.index - b.it.index;
      if (a.v === null) return 1;
      if (b.v === null) return -1;
      if (a.v !== b.v) return (a.v - b.v) * dir;
      return a.it.index - b.it.index;
    });
    return decorated.map(function (d) { return d.it; });
  }

  return { MODES: MODES, parseNum: parseNum, sortItems: sortItems };
});
